import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-richBlack" data-id="element-109">
      {/* Cinematic Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-zinc-900/40 via-richBlack to-richBlack z-0" data-id="element-110" />

      {/* Ambient gold glow behind wordmark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[60%] w-[700px] h-[400px] bg-gold/[0.06] rounded-full blur-[120px] pointer-events-none" data-id="element-111" />

      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto pt-24 md:pt-20" data-id="element-112">
        {/* Eye + Star brand mark */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-6 md:mb-8 flex justify-center" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/mDv3YyQZpEHyKfREvGAXFi/logo_.png" alt="Símbolo CRECEELITE" width={320} height={160} loading="eager" decoding="async" fetchPriority="high" className="w-36 sm:w-44 md:w-52 lg:w-60 h-auto object-contain mix-blend-screen" style={{
          filter: 'drop-shadow(0 0 16px rgba(212,175,55,0.5)) drop-shadow(0 0 32px rgba(212,175,55,0.28))'
        }} data-id="element-114" />
        </motion.div>

        {/* CRECEELITE wordmark with neon effect */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="font-montserrat font-extrabold tracking-[0.18em] md:tracking-[0.22em] text-4xl sm:text-5xl md:text-7xl lg:text-8xl mb-3 neon-text leading-none" data-id="element-115">
          <span className="text-warmWhite" data-id="element-116">CRECE</span>
          <span className="text-gold" data-id="element-117">ELITE</span>
        </motion.h1>

        {/* Decorative divider */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 1,
        scaleX: 1
      }} transition={{
        duration: 1,
        delay: 0.75,
        ease: [0.16, 1, 0.3, 1]
      }} className="mx-auto mb-8 md:mb-10 origin-center" data-id="element-118">
          <div className="w-24 md:w-32 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent mx-auto" data-id="element-119" />
        </motion.div>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.9,
        ease: 'easeOut'
      }} className="font-montserrat text-base md:text-2xl text-mutedGray font-light tracking-wide mb-10 md:mb-14" data-id="element-120">
          Descubre tu propósito. Vive en abundancia.
        </motion.p>

        {/* CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 w-full px-2 sm:px-0" data-id="element-121">
          <a href="#guia" className="w-full sm:w-auto text-center px-8 py-4 bg-gold text-richBlack font-montserrat font-semibold tracking-wide hover:bg-goldLight hover:scale-[1.02] transition-all duration-300 text-sm md:text-base shadow-[0_0_30px_rgba(201,168,76,0.2)] hover:shadow-[0_0_50px_rgba(212,175,55,0.4)]" data-id="element-122">
            Descargar guía gratuita
          </a>
          <a href="#pilares" className="w-full sm:w-auto text-center px-8 py-4 border border-warmWhite/30 text-warmWhite font-montserrat tracking-wide hover:border-gold hover:text-gold transition-all duration-300 text-sm md:text-base" data-id="element-123">
            Explorar los 5 fundamentos
          </a>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.8
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-mutedGray animate-bounce" data-id="element-124">
        <ArrowDownIcon className="w-6 h-6" data-id="element-125" />
      </motion.div>
    </section>;
}